import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { PriceDisplay } from './ui/PriceDisplay';
import { CheckCircleIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
export function OrderSummary() {
  const items = [{
    name: 'Biblia Visual — Guía Completa (500+ págs, 280+ imgs)',
    value: '$49.99'
  }, {
    name: 'Bono #1 — Guía de Pueblos Antiguos',
    value: '$19'
  }, {
    name: 'Bono #2 — Cronología Bíblica Ilustrada',
    value: '$29'
  }, {
    name: 'Bono #3 — Atlas de Mapas Bíblicos',
    value: '$15'
  }, {
    name: 'Bono #4 — Diccionario de Lugares Sagrados',
    value: '$25'
  }, {
    name: 'Bono #5 — Guía del Templo de Salomón',
    value: '$19'
  }, {
    name: 'Bono #6 — Guía de Estudio Interactiva',
    value: '$15'
  }, {
    name: 'Bono #7 — Actualizaciones de Por Vida',
    value: 'Infinito'
  }];
  return <section className="py-14 bg-white" data-id="element-214">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <FadeIn data-id="element-216">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-center text-navy-900 mb-10" data-id="element-217">
            Resumen de Todo Lo Que Recibes Hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-218">
          <FadeIn direction="right" className="lg:col-span-5" data-id="element-219">
            <div className="sticky top-20" data-id="element-220">
              <div className="aspect-[4/5] bg-cream rounded-xl border border-gray-200 flex flex-col items-center justify-center shadow-lg p-6 text-center" data-id="element-221">
                <span className="text-7xl mb-4" data-id="element-222">📚</span>
                <h3 className="text-xl font-bold font-heading text-navy-900 mb-1" data-id="element-223">
                  Biblia Visual
                </h3>
                <p className="text-gray-500 font-medium text-sm" data-id="element-224">
                  + 7 Bonos Exclusivos
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.15} className="lg:col-span-7" data-id="element-225">
            <div className="bg-cream rounded-2xl p-5 md:p-7 border border-gold/30 shadow-xl" data-id="element-226">
              <ul className="space-y-3 mb-5" data-id="element-227">
                {items.map((item, index) => <li key={index} className="flex items-start justify-between gap-3 pb-3 border-b border-gray-200 last:border-0 last:pb-0" data-id="element-228">
                    <div className="flex items-start gap-2" data-id="element-229">
                      <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-230" />
                      <span className={`text-sm text-gray-800 ${index === 0 ? 'font-bold' : 'font-medium'}`} data-id="element-231">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-red-500 line-through text-xs font-medium whitespace-nowrap" data-id="element-232">
                      {item.value}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-white rounded-xl p-5 border border-gray-200 mb-5 text-center" data-id="element-233">
                <p className="text-gray-500 font-medium mb-1 text-sm" data-id="element-234">
                  VALOR TOTAL:
                </p>
                <p className="text-xl text-red-500 line-through font-bold mb-3" data-id="element-235">
                  $171.99+
                </p>

                <p className="text-base font-bold text-navy-900 mb-1" data-id="element-236">
                  Hoy lo obtienes TODO por solo:
                </p>
                <PriceDisplay amount={14.99} size="lg" className="mb-1" data-id="element-237" />
              </div>

              <Button fullWidth className="py-4 text-lg md:text-xl mb-4 animate-pulse-slow" data-id="element-238">
                AGREGAR AL CARRITO
              </Button>

              <div className="flex flex-col items-center gap-3" data-id="element-239">
                <div className="flex flex-wrap justify-center gap-3 text-xs font-medium text-gray-600" data-id="element-240">
                  <span className="flex items-center gap-1" data-id="element-241">
                    <LockIcon className="w-3.5 h-3.5" data-id="element-242" /> Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-243">
                    <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-244" /> Pago único
                  </span>
                  <span className="flex items-center gap-1" data-id="element-245">
                    <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-246" /> 120 días de
                    garantía
                  </span>
                </div>
                <p className="text-[11px] text-gray-400 italic text-center" data-id="element-247">
                  Me reservo el derecho de cerrar esta oferta sin aviso previo.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}